export default {
  methods: {
    bannerCardKey(promotion = {}) {
      const { endDate } = promotion || {};

      if (!endDate) {
        return new Date();
      }

      if (endDate instanceof Date) {
        return endDate;
      }

      return new Date(endDate);
    },
  },
};
